<script lang="ts">
    import ScenarioRow from "./ScenarioRow.svelte";
    import { createEventDispatcher } from "svelte";
    import { _ } from "svelte-i18n";
    import { appManager } from "../../AppManager";
    import type { ScenarioData } from "../../api/projects/data/scenarios/ScenarioData";
    import type { ProjectDetailsData } from "../../api/projects/data/projects/ProjectDetailsData";

    export let scenarios: ScenarioData[];
    export let project: ProjectDetailsData;

    const dispatch = createEventDispatcher();

    let canOpenProject = true;
    appManager.getCanOpenProjects().subscribe((id) => {
        canOpenProject = id;
    })
</script>

<div class="card card-bleed shadow-light-lg">
    <div class="card-header">
        <div class="row align-items-center">
            <div class="col">
                <h4 class="mb-0">Scenarios</h4>
            </div>
            <div class="col-auto">
                {#if canOpenProject}
                <button
                    class="btn btn-xs btn-primary ms-auto"
                    on:click={() => {
                        dispatch("create");
                    }}>
                    {$_("impact.project.newScenario")}
                </button>
                {/if}
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="list-group list-group-flush">
            {#each scenarios as scenario, i}
                <ScenarioRow
                    {scenario}
                    {project}
                    on:copy={() => dispatch("copy", { scenario, i })}
                    on:remove={() => dispatch("remove", { scenario, i })} />
            {/each}
        </div>
    </div>
</div>
